import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogListComponent } from './catalog-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';
import { CatalogItemModule } from '../catalog-item';

@NgModule({
    declarations: [CatalogListComponent],
    exports: [CatalogListComponent],
    imports: [CommonModule, RouterModule, CatalogItemModule, TranslateModule.forChild(), LocalizeRouterModule.forChild([])],
    providers: []
})
export class CatalogListModule {}
